import http from '../../helpers/http-common';
import {
  MUTATION_LOAD_PRINT_PLATE_DIMENSIONS,
  MUTATION_SET_FILTERS
} from '../../mutation-types';
import { ACTION_LOAD_PRODUCT } from './action-types';
import {
  MUTATION_GET_PRICE,
  MUTATION_IS_LOADED,
  MUTATION_SET_PRICE,
  MUTATION_UPDATE_PRODUCT
} from './mutation-types';
import { ACTION_COMPOSITION_PRODUCT_SWITCH_COMPOSITION } from '../composition/action-types';
import { CREATOR_API } from '../../../api/creator-api';

export default {
  async [ACTION_LOAD_PRODUCT]({ commit, dispatch }, { articleNumber }) {
    commit(MUTATION_IS_LOADED, false);

    http
      .get(`/product/${articleNumber}`)
      .then(prodRes => {
        if (prodRes.status !== 200 || prodRes.status !== 200) {
          throw 'Unable to fetch product';
        }
        commit(MUTATION_UPDATE_PRODUCT, prodRes.data);
        commit(MUTATION_LOAD_PRINT_PLATE_DIMENSIONS, prodRes.data.printPlate, {
          root: true
        });
        dispatch(ACTION_COMPOSITION_PRODUCT_SWITCH_COMPOSITION, prodRes.data, {
          root: true
        });
      })
      .catch(err => {
        // TODO: Show error
        console.error(err);
      })
      .finally(() => {
        commit(MUTATION_IS_LOADED, true);
      });
  },
  // eslint-disable-next-line
  async [MUTATION_GET_PRICE]({ commit, state, getters }, composition) {
    commit(
      MUTATION_SET_PRICE,
      await CREATOR_API.price.resolve(getters.articleNumber, composition)
    );
  },
  [MUTATION_SET_FILTERS]: (state, filters) => {
    state.filters = filters;
  }
};
